import { IAppState } from '../../../AppModulesWrapper';

export function selectIsServicesReloading(state: IAppState): boolean {
  const {
    publishTerms: { isServicesReloading },
  } = state.servicePickerWidget;

  return isServicesReloading;
}
